/* ⚠️ MG 15 Aug 2026 — THIS FILE CARRIES MADE GOOD CUSTOMISATIONS.
   Added during the 15 Aug register rebuild. This file differs from stock Flex 5.6.0 but had no
   marker of its own, so an OOTSB update would present it as ordinary theme code and the changes
   could be accepted away without anyone noticing.
   >>> Do NOT take the stock/default version wholesale in an update conflict. Diff it first. <<<
   What differs has not been catalogued line by line — see customisation-register-2026-08-15.md in
   Google Drive › Shared drives › Management › Admin & Office › Claude › Projects › Flex 5.6.0 rebuild V2 */
/* mg-mm-new-item-close.js - Mega-menu open/close choreography for the Makers menu.
   Loaded after z__jsHeader.js; rebinds one delegated handler from that file's trailing block.
   FULL ANNOTATED HISTORY (fixes 2-12, what was measured, and the dead ends): see
   "Mega menu fix log.md" in the project folder. Only the essentials are kept inline below.

   ================================ INTENDED BEHAVIOUR ================================
     1. Cursor onto "New" -> any open panel starts closing STRAIGHT AWAY, no hover-intent delay.
     2. Moving DIRECTLY between two dropdown items (Shop <-> Collections) -> the panel STAYS OPEN
        and only its content swaps (the theme's original behaviour, restored).
     3. Makers: ALL content -- maker image, title, index letters and names -- fades in TOP TO BOTTOM.
        Never left-to-right zones (that is layout_1's cadence).
     4. Makers closes faster than the others (MAKERS_CLOSE_MS), with no delay.
     5. Makers opens with a solid background from the first frame.
     6. Makers plays its reveal from EVERY entry direction, including laterally along the nav row.
     7. Once Makers starts closing it KEEPS closing. Landing on another header item must never snap
        the remainder away, and must never re-open it.

   ============ FACTS ABOUT THE MARKUP (measured, not assumed) ============
     - Makers is .megamenu-layout_2; Shop and Collections are .megamenu-layout_1.
     - .has-submenu is NOT Makers-specific: Shop has 9 such columns, Makers 20, Collections 0.
     - Makers is two levels deep: column > a (index letter) AND column > ul.navbar-submenu (67 names).
       Every other menu has only direct `> a` links.
     - Intro block is .section > .mm-l2-intro, holding .mega-menu-images.layout_2 (photo, y=40) and
       .layput_2_header ("Our Makers 67", y=320). Note the theme's typo: layput, not layout.
     - All panels share z-index 20 (hovered/active gets 21 below), so paint order is otherwise DOM
       order and Makers is LAST. Makers is also TALLER: 749px vs 575px -- which is why a lingering
       Makers panel is only ever visible as a strip BELOW the other menus.

   ================ THREE LAWS THIS FILE KEEPS RE-LEARNING ================
   (A) A CSS transition needs a PAINTED start frame. If an element becomes visible in the same frame
       the animated property changes, the browser has no start value and jumps to the end -- no CSS
       change can fix it. Prime it across TWO rAFs from JS (one rAF can land in the same style-recalc
       batch). This caused FIX 6c (text) and FIX 9 (panel).
   (B) transitionDuration lies. It reports a duration whether or not anything is running.
       Check element.getAnimations().length instead.
   (C) Synthetic mouseover does NOT set :hover. Any bug caused by a :hover-only rule is invisible to
       synthetic testing and will measure as working. Use real CDP input (chrome-devtools hover).
       This hid FIX 8 for twelve sessions.

   ================ THE SHORT VERSION OF EACH FIX ================
   FIX 2  Outgoing panel re-opened mid-swap. Entering an item strips .active from the others (the open
          rule keys off .active). The .mg-mm-snap selector repeats 3x purely for specificity.
          !! snap is VISIBILITY-ONLY -- it must NOT force clip-path closed, or the return trip plays a
          full reveal instead of rule 2's instant content swap.
   FIX 3  Frost pulsed off when crossing "New". body.mg-frost-hold holds it; FROST_HOLD_MS tracks
          MAKERS_CLOSE_MS.
   FIX 4b Makers close cut from 1.22s (0.92s after a 0.3s delay) to 600ms, no delay.
   FIX 5  Panel opacity pinned to 1 in EVERY state -- with no value change there is nothing to animate,
          which sidesteps a :hover-only rule in mg-p23.css that wins the first hovered frame.
   FIX 6c Makers text never eased in: anims=0, no painted start frame. Driven from JS via .mg-rv ->
          2x rAF -> .mg-rv-go. See law (A).
   FIX 7  Logo/header flicker. All header hold rules read ONE token,
          --mg-mm-headerhold = 920+300 = 1220ms, but FIX 4b made Makers close in 600ms. The header held
          an open-menu state ~620ms after the panel left, then caught up in a separate late fade.
          Fixed by retiming the TOKEN (body.mg-mm-fastclose), not by adding another override.
          LESSON: diff durations before hunting the cascade.
   FIX 8  "Opens transparent / ABCs pop in / text vanishes on close" -- ONE cause, three symptoms.
          mg-tweaks.css had :hover-ONLY !important rules forcing layout_2's submenus and their li to
          visibility:visible;opacity:1. They match on the first hovered frame while the panel's own
          reveal waits for body.dropdown-visible -- and visibility:visible on a descendant overrides a
          hidden ancestor. So the names escaped the panel entirely. Now visibility:inherit, and
          endReveal defers its reset so text rides the panel down instead of snapping out.
   FIX 9  Makers popped open when entered laterally: mg-tweaks' .mg-warmed rule pre-opens EVERY sibling
          panel on row entry (deliberate -- it is what makes Shop <-> Collections swap instantly), so
          Makers had finished opening before the cursor arrived. layout_2 is exempted from the pre-warm,
          and the open is primed with .mg-pv per law (A).
   FIX 10 Content cadence. Per-ROW targets with a --mg-rvd delay from each element's Y within the panel
          -- position-based, not column-based, so a row starts together whatever column it is in.
          To retune the sweep, change REVEAL_SPREAD_MS only.
   FIX 11 Maker photo and title joined that same sweep (the photo previously ran on the theme's own
          zone-delayed .mega-menu-images fade, i.e. yet another clock).
   FIX 12 Makers flashed away under Collections. Reproducing it needed the REAL cursor path: Makers is
          rightmost, so reaching Collections crosses "New" -- a TRUE close -- and Collections is then
          entered MID-close. A straight teleport never reproduces it, which is why it survived earlier
          attempts. Measured (close stretched to 6s to make a mid-close swap reachable):
              9467  clip=61.3%  vis=visible  anims=2   <- closing normally
              9496  clip=100%   vis=hidden   anims=0   <- ONE frame later. Snapped.
          Three rules each kill an in-flight close: .mg-mm-snap (7 classes), mg-tweaks' .mg-warmed rule
          (8), and FIX 9's parking rule (9). Whichever wins, the remaining strip below Collections
          disappears in a single frame -- the flash. Fixed with a .mg-closing state (x5 = specificity
          10) that declares the SAME end value and SAME transition the close is already running, so it
          cannot restart or cancel the animation; it only stops the other three taking over.
          startReveal clears it so re-entry mid-close re-opens normally instead of staying pinned shut.

   ================== DEAD ENDS (do not redo) ==================
   PASS 1: relatedTarget only -> outgoing panel lingered visibly.
   PASS 2: 160ms hover-intent grace -> delays the close; Will wants it immediate.
   PASS 3: sequenced close-then-open -> broke behaviour rule 2 and caused the re-open. ~2.1s, unusable.
   FIX 5 v1: retiming opacity on the open rule -> lost the race with mg-p23's :hover-only rule.
   FIX 6 v1: closed rule more specific than shown rule -> menu opened blank.
   FIX 6 v2: matched specificity, :hover-driven -> transition still never started (anims=0).
   FIX 9 v1: parking the clip closed alone -> still snapped; needed the .mg-pv priming, law (A).

   Nothing here calls preventDefault or touches pointer-events. To revert: delete this file and
   its script tag in layout/theme.liquid. */
(function () {
  var MAKERS_CLOSE_MS = 600;
  var FROST_HOLD_MS = 600;
  var HOLD_RESET_MS = 1800; /* FIX 7 - outlives z__jsHeader's ~1700ms mg-mm-holding removal */
  var DRIFT_COLUMNS = 24;
  var DRIFT_STEP_MS = 28;
  var REVEAL_SPREAD_MS = 260; /* FIX 10 - total top-to-bottom sweep across the Makers panel */

  var PARKED = 'calc(var(--mg-mm-expand) + var(--mg-mm-closedelay))';
  var MK = '.navbar-item.has-dropdown--horizontal.megamenu-layout_2';
  var PANEL = ' .navbar-dropdown.is-horizontal';
  var COL = ' .section .horizontal-dropdown__column';
  var SUB = COL + ' > .navbar-submenu';   /* FIX 8 */
  var INTRO = ' .section .mm-l2-intro > *';   /* FIX 11 - maker photo + "Our Makers" title */

  /* Shop's maker-name lists keep mg-tweaks' left-to-right cadence */
  function driftCSS() {
    var base =
      '.megamenu-layout_1 .navbar-dropdown.is-horizontal .section .horizontal-dropdown__column > .navbar-submenu{' +
        'opacity:0;transform:translateY(var(--mg-mm-drift));' +
        'transition:opacity 0s linear ' + PARKED + ',transform 0s linear ' + PARKED + ';}';
    var shown =
      '.megamenu-layout_1.has-dropdown--horizontal:hover .section .horizontal-dropdown__column > .navbar-submenu,' +
      '.megamenu-layout_1.has-dropdown--horizontal:focus-within .section .horizontal-dropdown__column > .navbar-submenu{' +
        'opacity:1;transform:none;' +
        'transition:opacity var(--mg-mm-textdur) var(--mg-mm-ease),' +
                   'transform var(--mg-mm-textdur) var(--mg-mm-ease);}';
    var stagger = '';
    for (var i = 1; i <= DRIFT_COLUMNS; i++) {
      var d = (i - 1) * DRIFT_STEP_MS;
      stagger +=
        '.megamenu-layout_1.has-dropdown--horizontal:hover .section .horizontal-dropdown__column:nth-child(' + i + ') > .navbar-submenu{' +
          'transition-delay:' + d + 'ms,' + d + 'ms;}';
    }
    return base + shown + stagger;
  }

  /* FIX 6c/10/11 -- Makers reveal, driven by .mg-rv / .mg-rv-go from JS. Per-ROW targets so the
     sweep can run top-to-bottom; the delay itself comes from applyStagger via --mg-rvd. */
  function makersRevealCSS() {
    var t = function (prefix) {
      return prefix + COL + ' > a,' + prefix + SUB + ' > li,' + prefix + INTRO;
    };
    var start =
      t(MK + PANEL) + ',' + t(MK + '.mg-rv' + PANEL) + '{' +
        'opacity:0!important;transform:translateY(var(--mg-mm-drift))!important;' +
        'transition:none!important;}';
    var go =
      t(MK + '.mg-rv.mg-rv-go' + PANEL) + '{' +
        'opacity:1!important;transform:none!important;' +
        'transition:opacity var(--mg-mm-textdur) var(--mg-mm-ease),' +
                   'transform var(--mg-mm-textdur) var(--mg-mm-ease),' +
                   'color .3s ease-in-out!important;' +
        'transition-delay:var(--mg-rvd,0s),var(--mg-rvd,0s),0s!important;}';
    return start + go;
  }

  function makersCloseCSS() {
    return MK + PANEL + '{' +
      'transition:clip-path ' + MAKERS_CLOSE_MS + 'ms var(--mg-mm-closeease) 0s,' +
                 'opacity 0s linear ' + MAKERS_CLOSE_MS + 'ms,' +
                 'visibility 0s linear ' + MAKERS_CLOSE_MS + 'ms!important;}';
  }

  function makersOpaqueCSS() {
    return MK + PANEL + '{opacity:1!important;}';
  }

  /* FIX 8 -- names follow the PANEL instead of :hover, so they can't outrun or outlive it.
     FIX 10 -- the container is pinned opaque; the fade now lives on the individual li. */
  function makersInheritCSS() {
    return MK + PANEL + SUB + '{visibility:inherit!important;opacity:1!important;}' +
           MK + PANEL + SUB + ' > li{visibility:inherit!important;}';
  }

  /* FIX 12 -- let an in-flight Makers close finish. Same end value + same transition as the close
     already running, so this re-declaration cannot restart it; it only outranks .mg-mm-snap (7),
     mg-tweaks' .mg-warmed rule (8) and FIX 9's parking rule (9). Hence .mg-closing x5 = 10. */
  function makersClosingCSS() {
    return MK + '.mg-closing.mg-closing.mg-closing.mg-closing.mg-closing' + PANEL + '{' +
      'visibility:visible!important;clip-path:inset(0 0 100% 0)!important;' +
      'transition:clip-path ' + MAKERS_CLOSE_MS + 'ms var(--mg-mm-closeease) 0s,' +
                 'opacity 0s linear ' + MAKERS_CLOSE_MS + 'ms,' +
                 'visibility 0s linear ' + MAKERS_CLOSE_MS + 'ms!important;}';
  }

  /* FIX 9 -- keep Makers out of the sibling pre-warm, and give its open a painted start frame */
  function makersLateralCSS() {
    return 'body.dropdown-visible ' + MK + '.mg-warmed:not(:hover):not(.active)' + PANEL +
      '{clip-path:inset(0 0 100% 0)!important;transition:none!important;}' +
      /* .mg-pv x3 to outrank the .mg-mm-snap visibility:hidden rule (7 classes) */
      MK + '.mg-pv.mg-pv.mg-pv' + PANEL +
      '{visibility:visible!important;clip-path:inset(0 0 100% 0)!important;transition:none!important;}';
  }

  function injectCSS() {
    if (document.getElementById('mg-mm-swap-css')) return;
    var s = document.createElement('style');
    s.id = 'mg-mm-swap-css';
    s.textContent =
      '.navbar-item.has-dropdown--horizontal.mg-mm-snap.mg-mm-snap.mg-mm-snap .navbar-dropdown.is-horizontal{' +
        'visibility:hidden!important;transition:none!important;}' +
      'body.dropdown-visible .navbar-item.has-dropdown--horizontal:hover .navbar-dropdown.is-horizontal,' +
      'body.dropdown-visible .navbar-item.has-dropdown--horizontal.active .navbar-dropdown.is-horizontal,' +
      'body.dropdown-visible .navbar-item.has-dropdown--horizontal:focus-within .navbar-dropdown.is-horizontal{' +
        'z-index:21!important;}' +
      'body.mg-frost-hold .mg-mega-frost{opacity:1!important;visibility:visible!important;}' +
      'body.mg-mm-fastclose{--mg-mm-headerhold:' + MAKERS_CLOSE_MS + 'ms;}' +
      makersCloseCSS() +
      driftCSS() +
      makersRevealCSS() +
      makersOpaqueCSS() +
      makersInheritCSS() +
      makersLateralCSS() +
      makersClosingCSS();
    document.head.appendChild(s);
  }

  function init() {
    injectCSS();

    if (typeof window.jQuery === 'undefined') return;
    var $ = window.jQuery;
    var $row = $('.header__menu-items');
    if (!$row.length) return;
    if ($row.data('mgMmSwapBound')) return;
    $row.data('mgMmSwapBound', true);

    $row.off('mouseleave', '.navbar-item.has-dropdown--horizontal');

    var $items = function () { return $('.navbar-item.has-dropdown--horizontal'); };
    var frostTimer = null;

    function holdFrost() {
      if (frostTimer) { clearTimeout(frostTimer); frostTimer = null; }
      document.body.classList.add('mg-frost-hold');
      frostTimer = setTimeout(function () {
        frostTimer = null;
        document.body.classList.remove('mg-frost-hold');
      }, FROST_HOLD_MS);
    }
    function releaseFrost() {
      if (frostTimer) { clearTimeout(frostTimer); frostTimer = null; }
      document.body.classList.remove('mg-frost-hold');
    }

    /* FIX 7 -- header/logo hold retimed to whichever panel is actually closing */
    var holdTimer = null;
    function setFastClose() {
      if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; }
      document.body.classList.add('mg-mm-fastclose');
      holdTimer = setTimeout(function () {
        holdTimer = null;
        document.body.classList.remove('mg-mm-fastclose');
      }, HOLD_RESET_MS);
    }
    function clearFastClose() {
      if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; }
      document.body.classList.remove('mg-mm-fastclose');
    }

    /* FIX 8: per-element reset timer, so a re-entry can't be wiped by a stale close reset */
    var revealTimers = new WeakMap();
    function cancelReset(item) {
      var t = revealTimers.get(item);
      if (t) { clearTimeout(t); revealTimers.delete(item); }
    }

    /* FIX 12: mark a TRUE close so no later rule can snap the remainder away mid-flight */
    var closeTimers = new WeakMap();
    function markClosing(item) {
      var t = closeTimers.get(item);
      if (t) clearTimeout(t);
      item.classList.add('mg-closing');
      closeTimers.set(item, setTimeout(function () {
        closeTimers.delete(item);
        item.classList.remove('mg-closing');
      }, MAKERS_CLOSE_MS));
    }
    function clearClosing(item) {
      var t = closeTimers.get(item);
      if (t) { clearTimeout(t); closeTimers.delete(item); }
      item.classList.remove('mg-closing');
    }

    /* FIX 10/11: top-to-bottom sweep. Delay comes from each element's Y within the panel, so items on
       the same visual row fire together no matter which column they are in. */
    function applyStagger(item) {
      var panel = item.querySelector('.navbar-dropdown.is-horizontal');
      if (!panel) return;
      var box = panel.getBoundingClientRect();
      var h = box.height || 1;
      var els = panel.querySelectorAll(
        '.section .horizontal-dropdown__column > a,' +
        '.section .horizontal-dropdown__column > .navbar-submenu > li,' +
        '.section .mm-l2-intro > *');
      for (var i = 0; i < els.length; i++) {
        var y = els[i].getBoundingClientRect().top - box.top;
        var f = y / h;
        if (f < 0) f = 0; else if (f > 1) f = 1;
        els[i].style.setProperty('--mg-rvd', Math.round(f * REVEAL_SPREAD_MS) + 'ms');
      }
    }

    function startReveal(item) {
      if (!item.classList.contains('megamenu-layout_2')) return;
      cancelReset(item);
      clearClosing(item);   /* FIX 12: re-entry mid-close must not stay pinned shut */
      item.classList.remove('mg-rv-go');
      /* FIX 9: drop the snap first so .mg-pv can win, then paint the closed-but-visible start frame */
      item.classList.remove('mg-mm-snap');
      item.classList.add('mg-pv');
      item.classList.add('mg-rv');
      applyStagger(item);   /* FIX 10 */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          item.classList.remove('mg-pv');
          if (item.classList.contains('mg-rv')) item.classList.add('mg-rv-go');
        });
      });
    }

    /* FIX 8: defer the reveal reset until the panel has finished closing, so the text rides the
       panel down instead of snapping out the instant :hover is lost. immediate=true for swaps,
       where the outgoing panel is snap-hidden and an instant reset is invisible. */
    function endReveal(item, immediate) {
      if (immediate || !item.classList.contains('megamenu-layout_2')) {
        cancelReset(item);
        item.classList.remove('mg-pv');
        item.classList.remove('mg-rv');
        item.classList.remove('mg-rv-go');
        return;
      }
      cancelReset(item);
      revealTimers.set(item, setTimeout(function () {
        revealTimers.delete(item);
        item.classList.remove('mg-pv');
        item.classList.remove('mg-rv');
        item.classList.remove('mg-rv-go');
      }, MAKERS_CLOSE_MS));
    }

    $row.on('mouseleave', '.navbar-item.has-dropdown--horizontal', function (e) {
      var to = e.relatedTarget;
      var toDropdownItem = !!(to && $(to).closest('.navbar-item.has-dropdown--horizontal').length);

      endReveal(this);

      /* FIX 12: a TRUE close (cursor did NOT go to another dropdown item) must run to completion */
      if (!toDropdownItem && this.classList.contains('megamenu-layout_2')) markClosing(this);

      /* FIX 7: only the Makers panel closes in MAKERS_CLOSE_MS, so only it retimes the header */
      if (this.classList.contains('megamenu-layout_2')) { setFastClose(); } else { clearFastClose(); }

      if (!$row.is(':hover')) { releaseFrost(); return; }

      if (toDropdownItem) {
        $('body').addClass('dropdown-visible');
        $('html').addClass('scroll-locked');
        return;
      }

      holdFrost();
      $('body').removeClass('dropdown-visible');
      $('html').removeClass('scroll-locked');
      $items().removeClass('active');
      $('.horizontal-dropdown__column').removeClass('active');
    });

    $row.on('mouseenter.mgMmSwap', '.navbar-item.has-dropdown--horizontal', function () {
      var me = this;
      releaseFrost();
      /* FIX 7: entering Shop/Collections restores the 1220ms hold their panels still need */
      if (!me.classList.contains('megamenu-layout_2')) clearFastClose();
      startReveal(me);
      $items().each(function () {
        if (this === me) {
          this.classList.remove('mg-mm-snap');
        } else {
          this.classList.add('mg-mm-snap');
          this.classList.remove('active');
          endReveal(this, true);   /* FIX 8: snap-hidden, so reset now */
        }
      });
    });

    $row.on('mouseleave.mgMmSwap', function () {
      releaseFrost();
      $items().removeClass('mg-mm-snap').each(function () { endReveal(this); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
})();
